import firebase from "firebase";





// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDwCqzr7pazgfcxIxs-Lsg-tMXScOSpas8",
    authDomain: "challenge-88a83.firebaseapp.com",
    projectId: "challenge-88a83",
    storageBucket: "challenge-88a83.appspot.com",
    messagingSenderId: "42606142227",
    appId: "1:42606142227:web:a17ce7675232d6b3fe70e6",
    measurementId: "G-91SJT16N7V"
  };


  const firebaseApp = firebase.initializeApp(firebaseConfig);

  // These two lines give us viriables and allow us to sign in on various users
  const db = firebaseApp.firestore();
  const auth = firebase.auth();

  //It exports the previous 2 lines on data authentication
  export { db, auth };